export const iconFontAwesomeAutomotiveSprayCanSparkles = (
	<i className="fa-solid fa-spray-can-sparkles"></i>
);
